import { Routes, Route, Navigate } from "react-router-dom";
import { AuthGuard } from "@/components/AuthGuard.js";
import { AppLayout } from "@/layouts/AppLayout.js";
import { LoginPage } from "@/pages/LoginPage.js";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage.js";
import { VerifyEmailPage } from "@/pages/VerifyEmailPage.js";
import { DashboardPage } from "@/pages/DashboardPage.js";
import { MainPagesPage } from "@/pages/MainPagesPage.js";
import { MainPageEditPage } from "@/pages/MainPageEditPage.js";
import { TestsPage } from "@/pages/TestsPage.js";
import { TestEditPage } from "@/pages/TestEditPage.js";
import { SurveysPage } from "@/pages/SurveysPage.js";
import { SurveyEditPage } from "@/pages/SurveyEditPage.js";
import { StatsPage } from "@/pages/StatsPage.js";
import { ResponsesPage } from "@/pages/ResponsesPage.js";

export function App() {
  return (
    <Routes>
      {/* 인증 불필요 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      {/* 인증 필요 */}
      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/main-pages" element={<MainPagesPage />} />
        <Route path="/main-pages/:id/edit" element={<MainPageEditPage />} />
        <Route path="/tests" element={<TestsPage />} />
        <Route path="/tests/:id/edit" element={<TestEditPage />} />
        <Route path="/surveys" element={<SurveysPage />} />
        <Route path="/surveys/:id/edit" element={<SurveyEditPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/responses" element={<ResponsesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
